module.exports = __webpack_public_path__ + "static/media/google.4dc85b71.png";